var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:{'py-0': !_vm.isDesktop}},[_c('v-row',[_c('v-col',{class:{'px-0': !_vm.isDesktop},attrs:{"cols":"12 py-0"}},[_c('div',{staticClass:"d-flex flex-column",class:{'pt-0': _vm.isDesktop}},[_vm._t("default")],2)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }